<header class="page-header">
  <div class="page-header__row">
    <h1>Period comparison</h1>
    <span class="badge">Beta</span>
  </div>
  <p class="lede">Upload multiple XBRL filings from the same report set to compare metrics over time.</p>
</header>

<p class="notice">Coming soon — period trend analysis is on the roadmap.</p>

<app-file-upload-zone
  label="XBRL filings (same framework)"
  [multiple]="true"
  [disabled]="true"
  (filesSelected)="onFiles($event)"
/>
